import router from "../router";
import {deleteCookie, writeCookie} from "../utils";

export const unauthenticatedError = () => {
    writeCookie('auth', false, 30);
    deleteCookie('bearer_token');
    if (!router.currentRoute.value.meta.guest) {
        router.replace({ path: '/login' });
    }
}
